//Import for Webpack


import Module from 'core/ts/system/Module';

export default class RootModule extends Module {

}